// This file was automatically generated from appshared.medorder.cqmcds.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.medorder.cqmcds');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.medorder.cqmcds.cdsItems = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.cdsItems.length) {
    output.append('<fieldset class="noteFormBorder el8Dark" style="border: 1px solid #F4B552;">');
    var cdsItemList9749 = opt_data.cdsItems;
    var cdsItemListLen9749 = cdsItemList9749.length;
    for (var cdsItemIndex9749 = 0; cdsItemIndex9749 < cdsItemListLen9749; cdsItemIndex9749++) {
      var cdsItemData9749 = cdsItemList9749[cdsItemIndex9749];
      output.append('<p class="alert-item" data-id="', soy.$$escapeHtml(cdsItemData9749.id), '"><span class="el8UnderlineText">Alert:</span> ', soy.$$escapeHtml(cdsItemData9749.promptLabel), ' <a href="#" class="item-detail-trigger">More details</a></p>');
    }
    output.append('</fieldset>');
  }
  if (!opt_sb) return output.toString();
};
